export const CART_COUNT_EVENT = "cart-count-changed";
export const CART_REFRESH_EVENT = "cart-count-refresh";

export const normalizeCartCount = (count) => {
  const parsedCount = Number.parseInt(count, 10);
  return Number.isFinite(parsedCount) && parsedCount > 0 ? parsedCount : 0;
};

export const setCartCount = (count) => {
  const normalizedCount = normalizeCartCount(count);
  localStorage.setItem("cartLength", String(normalizedCount));
  window.dispatchEvent(
    new CustomEvent(CART_COUNT_EVENT, { detail: normalizedCount })
  );
  return normalizedCount;
};

export const refreshCartCount = () => {
  window.dispatchEvent(new Event(CART_REFRESH_EVENT));
};
